<template>
	<page class="dashboard" title="Fakturering" style="background-color: #F0F0F0;">
		<new-table-view class="list" @itemClick="itemClick" :columns="[
			{
				label: 'Kunde',
				name: 'name',
				weight: '10fr'
			},
			{
				label: 'Åbne',
				data: ' ',
				align: 'right'
			},
			{
				label: '30',
				name: ['_embedded', 'status', 'open_tasks'],
				align: 'right',
				weight: '100px'
			},
			{
				label: '144.450,00',
				name: ['_embedded', 'status', 'open_value'],
				align: 'right',
				filter: 'number',
				weight: '200px'
			},
			{
				label: 'Fakturerbare',
				data: ' ',
				weight: '200px',
				align: 'right'
			},
			{
				label: '22',
				name: ['_embedded', 'status', 'invoicable_tasks'],
				align: 'right',
				weight: '100px'
			},
			{
				label: '100.600,00',
				name: ['_embedded', 'status', 'invoicable_value'],
				align: 'right',
				filter: 'number',
				weight: '200px'
			},
		]" :items="_items" @context="itemContext" />
	</page>
</template>

<script>
	import { bus } from '../../bus'

    export default {
		data() {
			return {
				items: []
			};
		},
		components: {

		},
		watch: {

		},
		computed: {
			_items() {
				return [
					{
						name:	'Plethora',
						_embedded: {
							status: {
								open_tasks:			8,
								open_value:			32400,
								invoicable_tasks:	3,
								invoicable_value:	8500
							}
						}
					},
					{
						name:	'Spartan Software ApS',
						_embedded: {
							status: {
								open_tasks:			1,
								open_value:			3500,
								invoicable_tasks:	1,
								invoicable_value:	3500
							}
						}
					},
					{
						name:	'Spotrep',
						_embedded: {
							status: {
								open_tasks:			21,
								open_value:			108550,
								invoicable_tasks:	18,
								invoicable_value:	88600
							}
						}
					}
				];
			}
		},
		methods: {
			itemContext(item, event) {
				/*event.stopPropagation();

				var self = this;

				var actions = [];

				if (item.type == 'survey') {
					actions.push({
						label: 'Print privat',
						action: async function () {
							window.open(process.env.VUE_APP_API + '/planning/tasks/' + item.id + '/private/print/?token=' + self.$store.state.auth);
						}
					});

					actions.push({	
						label: 'Print erhverv',
						action: async function () {
							window.open(process.env.VUE_APP_API + '/planning/tasks/' + item.id + '/business/print/?token=' + self.$store.state.auth);
						}
					});

					actions.push(null);
				}

				actions.push({
					label: 'Slet',
					action: async function () {
						if (await TaskModel.delete(self.axios, item.id)) {
							self.update();
						}
					}
				});

				this.$store.state.popupController.toggle(ContextPopupView, {
					anchor: event.currentTarget,
					align: 'left',
					actions: actions
				});*/
			},
			async itemClick(item) {
				
			},
			async update() {
				
			}
		},
		mounted() {
			this.update();

			var self = this;

			bus.$on('update', function () {
				self.update();
			});

			bus.$on('clear', function () {
				self.items = null;
			});
		},
		beforeRouteLeave(to, from, next) {
			bus.$off('update');
			bus.$off('clear');

			next();
		}
    }
</script>

<style lang="scss" scoped>
	.layout {
		width: 100%;
		height: 100%;
		display: grid;
		grid-template-columns: 320px 1fr;
		grid-template-rows: 290px 1fr;

		& > .new-table-view {
			width: 100%;
			height: 100%;
		}
	}

	.date {
		grid-column: 1;
		grid-row: 1;
		background-color: #f0f0f0;
		padding: 30px;
	}

	.tasks {
		grid-column: 1;
		grid-row: 2 / 3;
		background-color: #f0f0f0;		
	}

	.list {
		width: 100%;
		height: 100%;
		border-left: 1px solid #cecece;
		background-color: white;
	}
</style>